// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IRenewalPlanDto
 */
export interface IRenewalPlanDto {
    /**
     * 
     * @type {number}
     * @memberof IRenewalPlanDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IRenewalPlanDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof IRenewalPlanDto
     */
    plan_code?: string;
    /**
     * 
     * @type {number}
     * @memberof IRenewalPlanDto
     */
    parent_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IRenewalPlanDto
     */
    account_type?: IRenewalPlanDtoAccountTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof IRenewalPlanDto
     */
    replenishment_bank_account_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IRenewalPlanDto
     */
    contribution_bank_account_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IRenewalPlanDto
     */
    prior_plan_id?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IRenewalPlanDto
     */
    is_custom_prefund_calc?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IRenewalPlanDto
     */
    is_replenished?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IRenewalPlanDto
     */
    funding_method_type?: IRenewalPlanDtoFundingMethodTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof IRenewalPlanDto
     */
    is_plan_level_funding?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IRenewalPlanDto
     */
    is_carded?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IRenewalPlanDto
     */
    allow_investments?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IRenewalPlanDto
     */
    grace_period_type?: IRenewalPlanDtoGracePeriodTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IRenewalPlanDto
     */
    run_out_type?: IRenewalPlanDtoRunOutTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof IRenewalPlanDto
     */
    is_rollover?: boolean;
    /**
     * 
     * @type {number}
     * @memberof IRenewalPlanDto
     */
    prefund_replenishment_percent?: number;
    /**
     * 
     * @type {string}
     * @memberof IRenewalPlanDto
     */
    replenishment_frequency?: IRenewalPlanDtoReplenishmentFrequencyEnum;
    /**
     * 
     * @type {number}
     * @memberof IRenewalPlanDto
     */
    replenishment_day_number?: number;
    /**
     * 
     * @type {string}
     * @memberof IRenewalPlanDto
     */
    max_rollover_amount_type?: IRenewalPlanDtoMaxRolloverAmountTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof IRenewalPlanDto
     */
    max_rollover_amount?: number;
    /**
     * 
     * @type {string}
     * @memberof IRenewalPlanDto
     */
    rollover_claims_type?: IRenewalPlanDtoRolloverClaimsTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof IRenewalPlanDto
     */
    min_rollover_amount?: number;
    /**
     * 
     * @type {string}
     * @memberof IRenewalPlanDto
     */
    min_rollover_amount_type?: IRenewalPlanDtoMinRolloverAmountTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof IRenewalPlanDto
     */
    rollover_claims_days_amount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IRenewalPlanDto
     */
    is_auto_enrollment?: boolean;
    /**
     * 
     * @type {number}
     * @memberof IRenewalPlanDto
     */
    days_after_plan_end?: number;
}

/**
* @export
* @enum {string}
*/
export enum IRenewalPlanDtoAccountTypeEnum {
    HSA = 'HSA',
    HCFSA = 'HCFSA',
    HRA = 'HRA',
    DCAP = 'DCAP',
    EXTERNAL = 'EXTERNAL',
    CLEARING = 'CLEARING',
    SUB_ACCOUNT = 'SUB_ACCOUNT',
    OMNIBUS = 'OMNIBUS',
    PARKING = 'PARKING',
    TRANSIT = 'TRANSIT',
    ADOPTION = 'ADOPTION',
    SPECIALTY = 'SPECIALTY',
    LIFESTYLE = 'LIFESTYLE',
    WAGEPARITY = 'WAGEPARITY',
    PLAN_OMNIBUS = 'PLAN_OMNIBUS',
    NOTIONAL_PAYROLL = 'NOTIONAL_PAYROLL',
    NOTIONAL_FUNDING = 'NOTIONAL_FUNDING',
    TRAVEL = 'TRAVEL'
}
/**
* @export
* @enum {string}
*/
export enum IRenewalPlanDtoFundingMethodTypeEnum {
    STANDARD_NOTIONAL = 'STANDARD_NOTIONAL',
    PREFUND_SPENDDOWN = 'PREFUND_SPENDDOWN',
    PREFUND_AND_CONTRIBUTION = 'PREFUND_AND_CONTRIBUTION',
    CONTRIBUTION_ONLY = 'CONTRIBUTION_ONLY'
}
/**
* @export
* @enum {string}
*/
export enum IRenewalPlanDtoGracePeriodTypeEnum {
    TWO_AND_HALF_MONTH = 'TWO_AND_HALF_MONTH',
    CUSTOM = 'CUSTOM',
    DOES_NOT_APPLY = 'DOES_NOT_APPLY'
}
/**
* @export
* @enum {string}
*/
export enum IRenewalPlanDtoRunOutTypeEnum {
    LAST_DAY_OF_PLAN_YEAR = 'LAST_DAY_OF_PLAN_YEAR',
    CUSTOM = 'CUSTOM',
    NO_CLAIMS_DEADLINE = 'NO_CLAIMS_DEADLINE'
}
/**
* @export
* @enum {string}
*/
export enum IRenewalPlanDtoReplenishmentFrequencyEnum {
    DAILY = 'DAILY',
    WEEKLY = 'WEEKLY',
    MONTHLY = 'MONTHLY'
}
/**
* @export
* @enum {string}
*/
export enum IRenewalPlanDtoMaxRolloverAmountTypeEnum {
    UNLIMITED = 'UNLIMITED',
    IRS_LIMIT = 'IRS_LIMIT',
    CUSTOM = 'CUSTOM'
}
/**
* @export
* @enum {string}
*/
export enum IRenewalPlanDtoRolloverClaimsTypeEnum {
    ALLOW_PRIOR_YEAR_CLAIMS = 'ALLOW_PRIOR_YEAR_CLAIMS'
}
/**
* @export
* @enum {string}
*/
export enum IRenewalPlanDtoMinRolloverAmountTypeEnum {
    NO_MINIMUM = 'NO_MINIMUM',
    CUSTOM = 'CUSTOM'
}


/**
 * Check if a given object implements the IRenewalPlanDto interface.
 */
export function instanceOfIRenewalPlanDto(value: object): value is IRenewalPlanDto {
    return true;
}

export function IRenewalPlanDtoFromJSON(json: any): IRenewalPlanDto {
    return IRenewalPlanDtoFromJSONTyped(json, false);
}

export function IRenewalPlanDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IRenewalPlanDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'plan_code': json['plan_code'] == null ? undefined : json['plan_code'],
        'parent_id': json['parent_id'] == null ? undefined : json['parent_id'],
        'account_type': json['account_type'] == null ? undefined : json['account_type'],
        'replenishment_bank_account_id': json['replenishment_bank_account_id'] == null ? undefined : json['replenishment_bank_account_id'],
        'contribution_bank_account_id': json['contribution_bank_account_id'] == null ? undefined : json['contribution_bank_account_id'],
        'prior_plan_id': json['prior_plan_id'] == null ? undefined : json['prior_plan_id'],
        'is_custom_prefund_calc': json['is_custom_prefund_calc'] == null ? undefined : json['is_custom_prefund_calc'],
        'is_replenished': json['is_replenished'] == null ? undefined : json['is_replenished'],
        'funding_method_type': json['funding_method_type'] == null ? undefined : json['funding_method_type'],
        'is_plan_level_funding': json['is_plan_level_funding'] == null ? undefined : json['is_plan_level_funding'],
        'is_carded': json['is_carded'] == null ? undefined : json['is_carded'],
        'allow_investments': json['allow_investments'] == null ? undefined : json['allow_investments'],
        'grace_period_type': json['grace_period_type'] == null ? undefined : json['grace_period_type'],
        'run_out_type': json['run_out_type'] == null ? undefined : json['run_out_type'],
        'is_rollover': json['is_rollover'] == null ? undefined : json['is_rollover'],
        'prefund_replenishment_percent': json['prefund_replenishment_percent'] == null ? undefined : json['prefund_replenishment_percent'],
        'replenishment_frequency': json['replenishment_frequency'] == null ? undefined : json['replenishment_frequency'],
        'replenishment_day_number': json['replenishment_day_number'] == null ? undefined : json['replenishment_day_number'],
        'max_rollover_amount_type': json['max_rollover_amount_type'] == null ? undefined : json['max_rollover_amount_type'],
        'max_rollover_amount': json['max_rollover_amount'] == null ? undefined : json['max_rollover_amount'],
        'rollover_claims_type': json['rollover_claims_type'] == null ? undefined : json['rollover_claims_type'],
        'min_rollover_amount': json['min_rollover_amount'] == null ? undefined : json['min_rollover_amount'],
        'min_rollover_amount_type': json['min_rollover_amount_type'] == null ? undefined : json['min_rollover_amount_type'],
        'rollover_claims_days_amount': json['rollover_claims_days_amount'] == null ? undefined : json['rollover_claims_days_amount'],
        'is_auto_enrollment': json['is_auto_enrollment'] == null ? undefined : json['is_auto_enrollment'],
        'days_after_plan_end': json['days_after_plan_end'] == null ? undefined : json['days_after_plan_end'],
    };
}

export function IRenewalPlanDtoToJSON(json: any): IRenewalPlanDto {
    return IRenewalPlanDtoToJSONTyped(json, false);
}

export function IRenewalPlanDtoToJSONTyped(value?: IRenewalPlanDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'plan_code': value['plan_code'],
        'parent_id': value['parent_id'],
        'account_type': value['account_type'],
        'replenishment_bank_account_id': value['replenishment_bank_account_id'],
        'contribution_bank_account_id': value['contribution_bank_account_id'],
        'prior_plan_id': value['prior_plan_id'],
        'is_custom_prefund_calc': value['is_custom_prefund_calc'],
        'is_replenished': value['is_replenished'],
        'funding_method_type': value['funding_method_type'],
        'is_plan_level_funding': value['is_plan_level_funding'],
        'is_carded': value['is_carded'],
        'allow_investments': value['allow_investments'],
        'grace_period_type': value['grace_period_type'],
        'run_out_type': value['run_out_type'],
        'is_rollover': value['is_rollover'],
        'prefund_replenishment_percent': value['prefund_replenishment_percent'],
        'replenishment_frequency': value['replenishment_frequency'],
        'replenishment_day_number': value['replenishment_day_number'],
        'max_rollover_amount_type': value['max_rollover_amount_type'],
        'max_rollover_amount': value['max_rollover_amount'],
        'rollover_claims_type': value['rollover_claims_type'],
        'min_rollover_amount': value['min_rollover_amount'],
        'min_rollover_amount_type': value['min_rollover_amount_type'],
        'rollover_claims_days_amount': value['rollover_claims_days_amount'],
        'is_auto_enrollment': value['is_auto_enrollment'],
        'days_after_plan_end': value['days_after_plan_end'],
    };
}

